import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import app from '@/main'
import Index from '@/routes/Index'
import { commonI18n } from '@/utils/i18n'

Vue.use(Router)

const defaultRoutes = [
  // 首页
  {
    path: '/',
    component: Index,
    meta: {
      layout: 'website'
    }
  },
  // 开通未来教室
  {
    path: '/openClass',
    component: () =>
      import('@/routes/openClass' /* webpackChunkName: 'openClass' */),
    meta: {
      layout: 'website'
    }
  },
  // 服务条款
  {
    path: '/termsService',
    name: 'termsService',
    component: () =>
      import('@/routes/termsService' /* webpackChunkName: 'termsService' */),
    meta: {
      layout: 'websiteNoFooter'
    }
  },
  // 隐私政策
  {
    path: '/privacyPolicy',
    name: 'privacyPolicy',
    component: () =>
      import('@/routes/privacyPolicy' /* webpackChunkName: 'privacyPolicy' */),
    meta: {
      layout: 'websiteNoFooter'
    }
  },
  // 登录
  {
    path: '/login',
    name: 'login',
    component: () => import('@/routes/Login' /* webpackChunkName: 'login' */),
    meta: {
      layout: 'websiteNoFooter'
    }
  },
  // 重置密码
  {
    path: '/resetPassword',
    name: 'resetPassword',
    component: () =>
      import('@/routes/ResetPassword' /* webpackChunkName: 'resetPassword' */),
    meta: {
      layout: 'websiteNoFooter'
    }
  },
  // 激活页面
  {
    path: '/activation',
    name: 'activation',
    component: () =>
      import('@/routes/Activation' /* webpackChunkName: 'activation' */),
    meta: {
      layout: 'websiteNoFooter'
    }
  },
  // 忘记密码
  {
    path: '/forgotPassword',
    name: 'forgotPassword',
    component: () =>
      import('@/routes/ForgotPassword' /* webpackChunkName: 'forgotPassword' */),
    meta: {
      layout: 'websiteNoFooter'
    }
  },
  // dashboard
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () =>
      import('@/routes/dashboard' /* webpackChunkName: 'dashboard' */),
    meta: {
      hideNav: true,
      layout: 'dashboard',
      needLogin: true
    }
  },
  // 班级管理
  {
    path: '/classManage',
    name: 'classManage',
    component: () =>
      import('@/routes/classManage' /* webpackChunkName: 'classManage' */),
    meta: {
      layout: 'dashboard',
      needLogin: true
    }
  },
  // 学生管理
  {
    path: '/studentManage',
    name: 'studentManage',
    component: () =>
      import('@/routes/studentManage' /* webpackChunkName: 'studentManage' */),
    meta: {
      layout: 'dashboard',
      needLogin: true
    }
  },
  // 作品管理
  {
    path: '/workManage',
    name: 'workManage',
    component: () =>
      import('@/routes/workManage' /* webpackChunkName: 'workManage' */),
    meta: {
      layout: 'dashboard',
      needLogin: true
    }
  },
  // 课程管理
  {
    path: '/courseManage',
    name: 'courseManage',
    component: () =>
      import('@/routes/courseManage' /* webpackChunkName: 'courseManage' */),
    meta: {
      layout: 'dashboard',
      needLogin: true
    }
  },
  // 教师管理
  {
    path: '/teacherManage',
    name: 'teacherManage',
    component: () =>
      import('@/routes/teacherManage' /* webpackChunkName: 'teacherManage' */),
    meta: {
      layout: 'dashboard',
      needLogin: true
    }
  },
  // 单位管理
  {
    path: '/unitManage',
    name: 'unitManage',
    component: () =>
      import('@/routes/unitManage' /* webpackChunkName: 'unitManage' */),
    meta: {
      layout: 'dashboard',
      needLogin: true
    }
  },
  {
    path: '/myWork',
    name: 'myWork',
    component: () => import('@/routes/myWork' /* webpackChunkName: 'myWork' */),
    meta: {
      layout: 'dashboard',
      needLogin: true
    }
  },
  // help
  {
    path: '/help',
    component: () => import('@/routes/Help' /* webpackChunkName: 'help' */),
    name: 'help',
    meta: {
      layout: 'dashboard',
      needLogin: true
    }
  },
  // tool
  {
    path: '/tool',
    component: () => import('@/routes/Tool' /* webpackChunkName: 'tool' */),
    name: 'tool',
    meta: {
      layout: 'dashboard',
      needLogin: true
    }
  },
  {
    path: '/viewer',
    component: () => import('@/routes/viewer' /* webpackChunkName: 'viewer' */),
    name: 'viewer',
    meta: {}
  },
  // ioe联合国教科文pdf播放
  {
    path: '/ioeViewer',
    component: () => import('@/routes/ioeViewer' /* webpackChunkName: 'ioeViewer' */),
    name: 'ioeViewer',
    meta: {}
  }
  // TODO: 暂时不开启学情报告
  // {
  //   path: '/learningStatistics',
  //   component: () => import('@/routes/learningStatistics' /* webpackChunkName: 'learningStatistics' */),
  //   name: 'learningStatistics',
  //   meta: {
  //     layout: 'dashboard',
  //     needLogin: true
  //   }
  // },
]

// 国际化路由
const langRoutes = defaultRoutes.map(({ path, name, component, meta }) => {
  return {
    path: `/:lang(en|zh-CN|zh-TW|it|id)${path}`, // 只允许/和/打头的域名检查，其余的都重定向到'/error'
    name: name ? 'lang_' + name : void 0,
    component,
    meta
  }
})

const router = new Router({
  mode: 'history',
  fallback: true,
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    ...defaultRoutes,
    ...langRoutes,
    {
      path: '*',
      name: 'error',
      component: resolve => require(['@/components/404'], resolve)
    }
  ]
})

// 语言设置
router.beforeResolve(async (to, from, next) => {
  await Promise.resolve()
  app.$i18n.locale = store.state.locale
  commonI18n.locale = store.state.locale
  next()
})

// 语言定义
router.beforeEach((to, from, next) => {
  const locale = to.params.lang || 'en'
  if (store.state.locales.indexOf(locale) === -1) {
    return next({ name: '/error' })
  }

  if (locale === 'en' && to.fullPath.indexOf('/en') === 0) {
    return next(to.fullPath.replace(/^\/en/, ''))
  }
  store.commit('SET_LANG', locale)
  next()
})

// 登录态
router.beforeEach((to, from, next) => {
  if (to.meta.needLogin) {
    if (!store.state.token) {
      return next('/login')
    }
  }
  next()
})

export default router
